import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CustomerAppsGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
			
		var customerAppsGrid = this;
		setTimeout(function(){
			customerAppsGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var customerAppsGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
			'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-text-field',
					itemid: 'filtername',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By Company Name',
					clearButtonVisible: true
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'applicationStatus',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'prevent-invalid-input': true,
					'keep-open': true,
					label: 'Status',
					clearButtonVisible: true,
					style: 'width: 11em;',
					postinit: function(combo) {
						Service.getLookupService().getLookupValues('ApplicationStatus').then(function(data) {
							var items = data ? data.slice() : [];
							items.unshift({
								code: '',
								description: 'All'
							});
							combo.items = items;
							combo.value = '';
						});
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startCurrentMonth());
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endCurrentMonth());
					}()
				},
				{
					tag: 'vaadin-button',
					itemid: 'search',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					children: [
						ElementUtil.makeIcon('vaadin:search', ' Search')
					],
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}
			]
		});

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					], 
					listeners: {
						click: function() {
							actionViewApp(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'span',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_CUSTOMER_APPLICATIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' New Application')
					],
					listeners: {
						click: function() {							
							actionCreateApp();
						}
					}					
				}		
			]
		});

		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'companyName',
					header: 'Company Name',					
					width: '7em'
				},
				{						
					path: 'applicationStatusDescription',
					header: 'Status',					
					width: '7em',
					'text-align': 'center'
				},				
				{						
					path: 'primaryContactFirstName',
					header: 'Contact First Name',					
					'flex-grow': '1'					
				},
				{						
					path: 'primaryContactLastName',
					header: 'Contact Last Name',						
					width: '9em'
				},
				{						
					path: 'preferredUserName',
					header: 'User Name',					
					width: '9em'
				},
				{						
					path: 'createDts',
					header: 'Create Date',					
					width: '9em',
					direction: 'desc',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.createDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);	
					}
				},
				{						
					path: 'createdCompanyId',
					header: 'Company Id',					
					width: '9em'
				},
				{
					path: 'companyTypeDescription',
					header: 'Company Type',
					hidden: true,
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'view').disabled = false; 					
					} else {						
						ElementUtil.query(toolbar, 'view').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					var startDateValue = ElementUtil.query(toolbarFilter, 'filterStartDate').value;
					var endDateValue = ElementUtil.query(toolbarFilter, 'filterEndDate').value;
					var startFilterDts = startDateValue ? TimeUtil.startOfDayCompanyTime(startDateValue) : null;
					var endFilterDts = endDateValue ? TimeUtil.endOfDayCompanyTime(endDateValue) : null;
					
					customerAppsGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'createDts',
						sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'DESC',
						start: startFilterDts,
						end: endFilterDts,
						dateField: 'createDts'
					};
					
					var filterNameValue = ElementUtil.query(toolbarFilter, 'filtername').value;
					if (filterNameValue) {
						customerAppsGrid.currentFilter.filterField = 'companyName';
						customerAppsGrid.currentFilter.filterValue = filterNameValue;
					}
					
					var applicationStatusValue = ElementUtil.query(toolbarFilter, 'applicationStatus').value;
					if (applicationStatusValue) {
						customerAppsGrid.currentFilter.applicationStatus = applicationStatusValue;
					}
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						customerAppsGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getCustomerApplicationService().getApplications(customerAppsGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'account-applications',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'account-applications.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		customerAppsGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		attachWorkspaceFilterState(customerAppsGrid, toolbarFilter, ['filtername', 'applicationStatus', 'filterStartDate', 'filterEndDate'], actionRefresh);
		
		var actionViewApp = function(app) {
			var viewAppWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Application',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {						
						viewAppWin.show();
					
						var loadView = function(record) {
							var fullView = [];
							fullView.push({
								key: 'General',
								section: true,
								value: '&nbsp;'
							});
							fullView.push({
								key: 'Company Name',
								value: record.applicationView.companyName
							});
							fullView.push({
								key: 'Carrier Type',
								value: record.applicationView.carrierTypeDescription
							});
							fullView.push({
								key: 'Broker Flag',
								value: record.applicationView.brokerFlag ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Shipper Flag',
								value: record.applicationView.shipperFlag ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Carrier Flag',
								value: record.applicationView.carrierFlag ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Reporting Timezone',
								value: record.applicationView.baseTimeZoneDescription || 'System Default'
							});
							fullView.push({
								key: 'Detail Status Failure',
								value: record.applicationView.detailedStatusFailure || '(Successful)'
							});							

							fullView.push({
								key: 'Addresses',
								section: true,
								value: '&nbsp;'
							});
							record.addresses.forEach(function(address){
								fullView.push({
									key: 'Address Type',
									value: address.addressTypeDescription
								});
								fullView.push({
									key: 'Address',
									value: address.addressLine1
								});
								fullView.push({
									key: 'City',
									value: address.cityName
								});
								fullView.push({
									key: 'State',
									value: address.stateProvinceCode
								});
								fullView.push({
									key: 'Country',
									value: address.countryCode
								});
							});


							fullView.push({
								key: 'Primary Contact',
								section: true,
								value: '&nbsp;'
							});
							fullView.push({
								key: 'First Name',
								value: record.applicationView.primaryContactFirstName
							});
							fullView.push({
								key: 'Last Name',
								value: record.applicationView.primaryContactLastName
							});
							fullView.push({
								key: 'Phone',
								value: record.applicationView.primaryContactPhone
							});
							fullView.push({
								key: 'Email',
								value: record.applicationView.primaryContactEmail
							});	
							fullView.push({
								key: 'Sent Sign Up Email',
								value: record.applicationView.sendSignupFlag ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});								


							fullView.push({
								key: 'Admin User',
								section: true,
								value: '&nbsp;'
							});
							fullView.push({
								key: 'Credentials',
								value: record.applicationView.preferredUserName + ' / ' + record.applicationView.preferredPassword
							});

							fullView.push({
								key: 'Payment Info',
								section: true,
								value: '&nbsp;'
							});
							fullView.push({
								key: 'Payment Type',
								value: record.applicationBillingModelView.paymentType
							});
							fullView.push({
								key: 'EFS Contract No',
								value: record.applicationBillingModelView.tchContractNo ? record.applicationBillingModelView.tchContractNo : 'N/A'
							});						


							fullView.push({
								key: 'Billing Settings',
								section: true,
								value: '&nbsp;'
							});
							fullView.push({
								key: 'Billing Start Date',
								value: TimeUtil.formatBillingCalendarDate(record.applicationBillingModelView.billingStartDate)
							});
							fullView.push({
								key: 'Cycle Day',
								value: record.applicationBillingModelView.cycleDay
							});
							fullView.push({
								key: 'Sales Rep',
								value: record.applicationBillingModelView.saleRepName
							});
							fullView.push({
								key: 'Billing Notice',
								value: record.applicationBillingModelView.sendBillingNotice ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Send Payment',
								value: record.applicationBillingModelView.sendPayment ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Send Invoice',
								value: record.applicationBillingModelView.sendInvoice ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Do Not Bill',
								value: record.applicationBillingModelView.doNotBill ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Bill A Cycle Back',
								value: record.applicationBillingModelView.billBehind ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
							});
							fullView.push({
								key: 'Referral Code',
								value: record.applicationBillingModelView.referralCode ? record.applicationBillingModelView.referralCode : 'Not Set' 
							});
							fullView.push({
								key: 'Promotion Code',
								value: record.applicationBillingModelView.promotionCode ? record.applicationBillingModelView.promotionCode : 'Not Used'
							});


							fullView.push({
								key: 'Products',
								section: true,
								value: '&nbsp;'
							});
							record.products.forEach(function(product){
								fullView.push({
									key: 'Product / Feature Code',
									value: product.applicationProductPK.productCode + ' / ' + product.applicationProductPK.featureProductCode
								});
								fullView.push({
									key: 'Feature Name',
									value: product.featureProductName
								});
								fullView.push({
									key: 'Price',
									value: StringUtil.currencyFormat(product.productPrice)
								});
							});


							fullView.push({
								key: 'Factoring',
								section: true,
								value: '&nbsp;'
							});						
							record.factorSetups.forEach(function(setup){
								fullView.push({
									key: 'Feature Name',
									value: setup.featureProductName
								});
								fullView.push({
									key: 'Initial factor count',
									value: setup.initalFactorCount
								});
								fullView.push({
									key: 'Override Flag',
									value: setup.overrideFlag ? '<vaadin-icon style="color: green" icon="vaadin:check"></vaadin-icon>' : '<b style="color: red">X</b>'
								});
							});
							viewGrid.items = fullView;	
						};
						
						
						
						var viewGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders wrap-cell-content',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [				
								{						
									path: 'key',
									header: 'Field',					
									width: '5em',
									renderer: function(root, column, rowData) {
										if (rowData.item.section) {
											root.style = 'background-color: grey; color: white; font-size: 20px; text-shadow: 2px 2px 2px #000;';
										} else if (rowData.item.subSection) {
											root.style = 'background-color: #c0dcf5;';
										} else {
											root.style = '';
										}
										root.innerHTML = '<b>' + rowData.item.key + '</b>';
									}
								},
								{						
									path: 'value',
									header: 'Value',						
									'flex-grow': '1',								
									renderer: function(root, column, rowData) {
										if (rowData.item.section) {
											root.style = 'background-color: grey; color: white; font-size: 20px;';
										} else if (rowData.item.subSection) {
											root.style = 'background-color: #c0dcf5;';
										} else {
											root.style = '';
										}
										root.innerHTML = rowData.item.value;
									}
								}				
							]
						});	
						
						var viewFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								viewGrid
							]
						});
						viewAppWin.addToContentElement(viewFlexLayout);	
						
						var loadMask = viewGrid.showLoading();
						BillingService.getCustomerApplicationService().getApplicationDetails(app.applicationId).then(function(existingApp){
							loadMask.remove();
							loadView(existingApp);							
						});
						
					}
				}
			});
						
		};		
		
		var actionCreateApp = function(record) {
		
			var showAppWin = function(ssoEnabled) {			
				var createAppWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'New Application',
				icon: 'vaadin:plus',
				listeners: {
					ready: function() {						
						createAppWin.show();
						
						
						var createLocalUserForm = function() {						
							var userForm = ElementUtil.create({
								tag: 'div',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-text-field',
												label: 'Username',
												name: 'preferredUserName',
												autocomplete: 'off',
												required: true,
												maxLength: 120
											},
											{
												tag: 'vaadin-password-field',
												label: 'Password',
												name: 'preferredPassword',
												autocomplete: 'new-password',
												'helper-text': 'Needs to be at least 8 characters, contain mix case, number and special character',
												required: true,
												maxLength: 80
											}
										]
									}
								]
							});
							return userForm;
						};
								
						var createExistingUserForm = function() {
						
							var userForm = ElementUtil.create({
								tag: 'div',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'dl-user-select',
												label: 'Existing Username',
												name: 'preferredUserName',
												autocomplete: 'off',
												required: true,
												maxLength: 120
											}											
										]
									}
								]
							});
							return userForm;
						};
						
						var createSSOUserForm = function() {
						
							var userForm = ElementUtil.create({
								tag: 'div',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-email-field',
												label: 'Username (Email Address)',
												name: 'preferredUserName',
												autocomplete: 'off',
												required: true,
												maxLength: 120
											}
										]
									}
								]
							});
							return userForm;
						};
						
						
						var products = [];
						var productGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'applicationProductPK.productCode',
									header: 'Product Code',					
									width: '9em',
									renderer: function(root, column, rowData) {
										root.innerHTML = rowData.item.applicationProductPK.productCode + '-' + rowData.item.applicationProductPK.featureProductCode;
									}
								},
								{
									path: 'description',
									header: 'Product',					
									'flex-grow': '1'
								},
								{						
									path: 'productPrice',
									header: 'Price',					
									width: '7em',
									'text-align': 'end',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.productPrice);
									}
								},
								{
									path: 'defaultBillingCycleDay',
									header: 'Default Bill Day',
									'text-align': 'center',
									width: '8em'
								},									
								{						
									path: 'initalFactorCount',
									header: 'Factor Count',
									'text-align': 'end',
									width: '7em'
								},								
								{
									path: 'overrideFlag',
									header: 'Factor Override',					
									width: '9em',
									'text-align': 'center',
									renderer: function(root, column, rowData) {
										root.innerHTML = rowData.item.overrideFlag ? true : false;
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									productGrid.selectedItems = item ? [item] : [];
									if (productGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editItem').disabled = false;										
										ElementUtil.query(formPanel, 'removeItem').disabled = false;										
									} else {	
										ElementUtil.query(formPanel, 'editItem').disabled = true;										
										ElementUtil.query(formPanel, 'removeItem').disabled = true;
									}	
								}
							}
						});										
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-number-field',
									itemid: 'carrierId',
									label: 'EFS Carrier Id',
									name: 'carrierId',											
									maxLength: 80
								},
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:search', ' Lookup')
									], 
									listeners: {
										click: function() {
											var carrierCB = ElementUtil.query(formPanel, 'carrierId');
											var carrierId = carrierCB ? carrierCB.value : null;
											actionLookupCarrier(carrierId);
										}
									}
								},
								{
									tag: 'fieldset',																					
									children: [											
										{
											tag: 'legend',
											innerHTML: 'Company Info'
										},
										{
											tag: 'vaadin-form-layout',	
											children: [	
												{
													tag: 'vaadin-text-field',
													label: 'Company Name',
													name: 'companyName',
													required: true,
													maxLength: 120
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Parent Company', 
													name: 'parentCompanyId',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													postinit: function(combo) {
														//Note this requires a different permission; The admin should have this.
														//If this was move to a user level this would need to change.
														//It would need to change anyway...since customer wouldn't use this field
														Service.getCompanyService().getCompaniesLookup().then(function(data){
															combo.items = data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Carrier Type', 
													name: 'carrierType',
													'item-value-path': 'code',
													'item-label-path': 'description',
													value: 'FLEET',													
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('CarrierType').then(function(data){
															combo.items = data;
															combo.required = true;
														});
													}
												},
												{
													tag: 'div',
													children: [										
														{
															tag: 'vaadin-checkbox',									
															name: 'shipperFlag',
															label: 'Shipper'
														},
														{
															tag: 'vaadin-checkbox',									
															name: 'brokerFlag',
															label: 'Broker'
														},
														{
															tag: 'vaadin-checkbox',									
															name: 'carrierFlag',
															label: 'Carrier',
															checked: true
														}
													]
												},
												{
													tag: 'vaadin-text-field',
													label: 'Address',
													name: 'addressLine1',	
													required: true,
													maxlength: 120
												},										
												{
													tag: 'vaadin-text-field',
													label: 'Postal Code',
													name: 'postalCode',
													required: true,
													maxlength: 40
												},
												{
													tag: 'vaadin-text-field',
													label: 'City',
													name: 'cityName',
													required: true,
													maxlength: 80
												},
												{
													tag: 'vaadin-combo-box',
													itemid: 'state',
													label: 'State/Providence', 
													name: 'stateProvinceCode',
													'item-value-path': 'code',
													'item-label-path': 'description',
													required: true,
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
															combo.items = data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Reporting TimeZone', 
													'helper-text': 'This will effect the timezone of data shown and reporting',
													name: 'baseTimeZone',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													placeHolder: 'Select',
													value: 'CST6CDT',
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('TimeZone').then(function(data){
															combo.items = data;
															combo.required = true;
														});
													}
												}
											]
										}
									]
								},
								{
									tag: 'fieldset',
									style: 'margin-top: 20px;',	
									children: [
										{
											tag: 'legend',
											innerHTML: 'Primary Contact'
										},
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													label: 'First name',
													name: 'primaryContactFirstName',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-text-field',
													label: 'Last Name',
													name: 'primaryContactLastName',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-text-field',
													label: 'Phone',
													name: 'primaryContactPhone',
													required: true,
													maxLength: 80
												},
												{
													tag: 'vaadin-email-field',
													label: 'Email',
													name: 'primaryContactEmail',
													required: true,
													maxLength: 200
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendSignupFlag',
													checked: true,
													label: 'Send Signup Email'													
												}
											]
										}

									]
								},
								{
									tag: 'fieldset',
									style: 'margin-top: 20px;',											
									children: [	
										{
											tag: 'legend',
											innerHTML: 'Admin User'
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'userAccountType',
											label: 'User Account Type', 
											name: 'userAccountType',
											'item-value-path': 'code',
											'item-label-path': 'description',													
											required: true,
											postinit: function(combo) {																								
												Service.getLookupService().getLookupValues('UserAccountType').then(function(data){
													var types = [];
													data.forEach(function(item){
														var add = true;
														if (!ssoEnabled && item.requiresSSOEnabled) {
															add = false;
														} 
														if (add) {
															types.push(item);
														}
													});
													
													combo.items = types;
												});
												
											},
											listeners: {
												change: function(e) {
													var value = e.srcElement.value;
													var container = ElementUtil.query(formPanel, 'userAccountContainer');
													
													ElementUtil.removeAllChildren(container);													
													if (value === 'LOCAL') {
														container.append(createLocalUserForm());
													} else if (value === 'EXISTING') {
														container.append(createExistingUserForm());
													} else {
														container.append(createSSOUserForm());
													}															
												}
											}
										}, 
										{								
											tag: 'div',
											itemId: 'userAccountContainer',
											children: [												
											]
										}										
									]
								},
								{
									tag: 'fieldset',
									style: 'margin-top: 20px; margin-bottom: 20px;',
									children: [	
										{
											tag: 'legend',
											innerHTML: 'Payment Info'
										},
										{
											tag: 'vaadin-form-layout',	
											children: [	
												{
													tag: 'vaadin-combo-box',
													itemid: 'paymentType',
													label: 'Payment Type', 
													name: 'paymentType',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													required: true,
													postinit: function(combo) {
														Service.getLookupService().getLookupValues('PaymentType').then(function(data){
															combo.items = data;
														});
													},
													listeners: {
														change: function() {
															var selection = ElementUtil.query(formPanel, 'paymentType').value;
															var contractCB = ElementUtil.query(formPanel, 'contract');
															if (selection === 'TCH') {
																contractCB.classList.remove('hide');
															} else {
																contractCB.classList.add('hide');
															}
														}
													}
												},
												{
													tag: 'vaadin-combo-box',
													itemid: 'contract',
													label: 'Contract', 
													name: 'tchContractNo',
													'item-value-path': 'code',
													'item-label-path': 'description',																																							
													postinit: function(combo) {	
														//need the element to size first then hide
														setTimeout(function(){															
															var contractCB = ElementUtil.query(formPanel, 'contract');
															contractCB.classList.add('hide');
														}, 50);
													}													
												}
											]
										}
									]
								},
								{
									tag: 'dl-section-title',
									title: 'Products',
									style: 'margin-top: 20px;'											
								},
								{
									tag: 'div',
									style: 'height: 250px;',								
									children: [
										{
											tag: 'dl-flex-layout',
											children: [
												{
													tag: 'dl-toolbar',
													slot: 'toolbar',
													theme: 'spacing',
													children: [																				
														{
															tag: 'vaadin-button',
															itemid: 'addItem',
															theme: 'primary',
															'class': 'spacer-toolbar-item',
															children:[
																ElementUtil.makeIcon('vaadin:plus', ' Add')
															],
															listeners: {
																click: function() {							
																	actionAddEditProduct();
																}
															}					
														},	
														{
															tag: 'vaadin-button',
															itemid: 'editItem',																	
															'class': 'spacer-toolbar-item',
															children:[
																ElementUtil.makeIcon('vaadin:edit', ' Edit')
															],
															listeners: {
																click: function() {							
																	actionAddEditProduct(productGrid.selectedItems[0]);
																}
															}					
														},
														{
															tag: 'vaadin-button',
															itemid: 'removeItem',
															theme: 'error primary',																						
															'class': 'spacer-toolbar-item',
															style: 'float: right;',					
															children:[
																ElementUtil.makeIcon('vaadin:close', ' Remove')
															],
															listeners: {
																click: function() {
																	actionRemoveProduct(productGrid.selectedItems[0]);
																}
															}
														}			
													]
												},
												productGrid													
											]
										}
									]										
								},
								{
									tag: 'fieldset',
									style: 'margin-top: 20px;',								
									children: [
										{
											tag: 'legend',
											innerHTML: 'Billing Settings'
										},
										{
											tag: 'vaadin-form-layout',	
											children: [	
												{
													tag: 'vaadin-date-picker',
													itemid: 'billingStartDate',
													label: 'Billing Start Date',												
													name: 'billingStartDate'							
												},
												{
													tag: 'vaadin-combo-box',
													itemid: 'cycleDay',
													label: 'Cycle Day', 
													name: 'cycleDay',
													'item-value-path': 'code',
													'item-label-path': 'description',
													value: '1',	
													required: true,
													postinit: function(combo) {
														var data = [];
														for (var i=1; i<29; i++) {
															data.push({
																code: '' + i,
																description: i
															});
														}
														combo.items = data;
													}																									
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Promotion Code', 
													name: 'promotionCode',
													'item-value-path': 'promotionCode',
													'item-label-path': 'promotionDesc',											
													postinit: function(combo) {
														BillingService.getBundlePromotionService().getPromotions().then(function(promotions){
															combo.items = promotions.data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Referral Code', 
													name: 'referralCode',
													'item-value-path': 'referralCode',
													'item-label-path': 'signupName',																									
													postinit: function(combo) {
														BillingService.getReferralService().getReferrals().then(function(referrals){
															combo.items = referrals.data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													label: 'Sale Representative', 
													name: 'salesRepId',
													'item-value-path': 'salesRepId',
													'item-label-path': 'description',																									
													postinit: function(combo) {
														BillingService.getSalesRepService().getSaleReps().then(function(salesRep){
															salesRep.data.forEach(function(rep){
																rep.description = rep.repFirstName + ', ' + rep.repLastName; 
															});
															combo.items = salesRep.data;
														});
													}
												},
												{													
													tag: 'vaadin-checkbox',									
													name: 'doNotBill',
													label: 'Do Not Bill'													
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendBillingNotice',
													colspan: 2,
													label: 'Billing Notices'	
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendInvoice',
													colspan: 2,
													label: 'Send Invoice Email'	
												},
												{
													tag: 'vaadin-checkbox',									
													name: 'sendPayment',
													colspan: 2,
													label: 'Send Payment Email'	
												}														
											]
										}										
									]
								},
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Submit')
											],
											listeners: {
												click: function() {															

													//check payment type
													var submitData = formPanel.getData();
													if (submitData.paymentType === 'TCH' && 
														!submitData.tchContractNo) {
														window.DL.MessageUtil.showOkMessage('A contract is required for TCH Payment Type.');
													} else {

														formPanel.submitForm({
															preSubmit: function(data) {		
																if (data.billingStartDate) {
																	data.billingStartDate = TimeUtil.normalizeBillingCalendarDateForSubmit(data.billingStartDate);
																}
																var stateCB = ElementUtil.query(formPanel, 'state');
																var stateCBValue = stateCB.selectedItem;

																var submitAccount = {
																	application: {
																		companyName: data.companyName,
																		carrierType: data.carrierType,
																		currencyCode: 'USD',
																		brokerFlag: data.brokerFlag ? data.brokerFlag : false,
																		shipperFlag: data.shipperFlag ? data.shipperFlag : false,
																		carrierFlag: data.carrierFlag ? data.carrierFlag : false,
																		billShipSameFlag: true,
																		prevOnlineUseFlag: false,
																		baseObserveDaylightSavFlag: true,
																		operObserveDaylightSavFlag: true,
																		baseTimeZone: data.baseTimeZone,
																		primaryContactLastName: data.primaryContactLastName,
																		primaryContactFirstName: data.primaryContactFirstName,		
																		primaryContactPhone: data.primaryContactPhone,
																		primaryContactEmail: data.primaryContactEmail,
																		preferredUserName: data.preferredUserName,
																		// Password is only collected for local accounts; SSO/existing omit it.
																		preferredPassword: (data.userAccountType === 'LOCAL' ? data.preferredPassword : null),
																		paymentType: data.paymentType,
																		userAccountType: data.userAccountType
																	},
																	applicationBillingModel: {
																		billingStartDate: data.billingStartDate,
																		cycleDay: data.cycleDay,																		
																		sendInvoice: data.sendInvoice ? data.sendInvoice : false,
																		sendPayment: data.sendPayment ? data.sendPayment : false,
																		sendBillingNotice: data.sendBillingNotice ? data.sendBillingNotice : false,
																		billBehind: data.billBehind ? data.billBehind : false,
																		doNotBill: data.doNotBill ? data.doNotBill : false,
																		overrideShutoff: false,
																		tchContractNo: data.tchContractNo,
																		tchAccountType: 'LC',
																		paymentType: data.paymentType
																	},
																	products: [],
																	addresses: [],
																	factorSetups: []																																	
																};
																if (data.parentCompanyId) {
																	submitAccount.application.parentCompanyId = data.parentCompanyId;	
																}

																if (formPanel.validCarrierId) {
																	submitAccount.application.carrierId = formPanel.validCarrierId;
																}
																if (data.salesRepId) {
																	submitAccount.applicationBillingModel.salesRepId = data.salesRepId;
																}
																
																if (data.referralCode) {
																	submitAccount.applicationBillingModel.referralCode = data.referralCode;
																}
																if (data.promotionCode) {
																	submitAccount.applicationBillingModel.promotionCode = data.promotionCode;
																}

																//address
																submitAccount.addresses.push({
																	stateProvinceCode: data.stateProvinceCode,
																	countryCode: stateCBValue.country,
																	addressType: 'BILLTO',
																	addressLine1: data.addressLine1,
																	postalCode: data.postalCode,
																	cityName: data.cityName
																});

																submitAccount.addresses.push({
																	stateProvinceCode: data.stateProvinceCode,
																	countryCode: stateCBValue.country,
																	addressType: 'SHIPTO',
																	addressLine1: data.addressLine1,
																	postalCode: data.postalCode,
																	cityName: data.cityName
																});

																//products
																products.forEach(function(product){
																	submitAccount.products.push({
																		applicationProductPK: {
																			productCode: product.applicationProductPK.productCode,
																			featureProductCode: product.applicationProductPK.featureProductCode																		
																		},															
																		productPrice: product.productPrice,
																		orderQtyAmount: product.orderQtyAmount,
																		quantityUom: product.quantityUom
																	});
																	if (product.initalFactorCount) {
																		submitAccount.factorSetups.push({
																			productCode: product.applicationProductPK.productCode,
																			featureProductCode: product.applicationProductPK.featureProductCode,
																			initalFactorCount: product.initalFactorCount,
																			overrideFlag: product.overrideFlag
																		});
																	}
																});

																return submitAccount;
															},
															actualCall: function(data) {																
																return BillingService.getCustomerApplicationService().saveApplication(data);
															},
															success: function(data, responseData) {
																window.DL.MessageUtil.showToast('Success', 'Created a new Account', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																actionRefresh();
																createAppWin.close();
															}
														});
													}
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											listeners: {
												click: function() {
													//cancel
													createAppWin.close();
												}
											}
										}
									]
								}
							]						
							
						});
						createAppWin.addToContentElement(formPanel);							
				
						var actionLookupCarrier = function(carrierId) {
							if (carrierId) {
								var loadMask = formPanel.showLoading();
								BillingService.getCustomerApplicationService().getEFSCarrier(carrierId).then(function(carrierData){
									loadMask.remove();
									
									if (carrierData.carrierInfo) {
									
										var loadModel = {
											companyName: carrierData.carrierInfo.name,
											primaryContactFirstName: carrierData.carrierInfo.contactFirstname,
											primaryContactLastName: carrierData.carrierInfo.contactLastname,
											primaryContactPhone: carrierData.carrierInfo.contactPhone,
											primaryContactEmail: carrierData.carrierInfo.email,
											addressLine1: carrierData.carrierInfo.address,	
											postalCode: carrierData.carrierInfo.zip,
											cityName: carrierData.carrierInfo.city,
											stateProvinceCode: carrierData.carrierInfo.state,
											paymentType: 'TCH'	
										};

										formPanel.load(loadModel);
										formPanel.validCarrierId = carrierId;

										//load Contracts
										var contractCB = ElementUtil.query(formPanel, 'contract');
										var contractData = [];
										carrierData.contracts.forEach(function(item){
											contractData.push({
												code: item.contractId,
												description: 'Id: ' + item.contractId + 
														     ' Limit: ' + item.creditLimit + 
															 ' Last Transaction: ' + TimeUtil.formatDateStandard(item.lastTransaction) +
															 ' Status: ' + item.status + 
															 ' Limit Method: ' + item.limitMethod + 
															 ' Daily Limit: ' + item.dailyLimit
											});
										});										
										
										contractCB.items = contractData;
										
										var paymentTypeCB = ElementUtil.query(formPanel, 'paymentType');
										var event = new Event('change');
										paymentTypeCB.dispatchEvent(event);
										
										
									} else {										
										window.DL.MessageUtil.showOkMessage('Carrier Id not found.');
									}	 
									
								});
								
							} else {
								window.DL.MessageUtil.showOkMessage('Enter a carrier id to lookup.');
							}
						};				
				
						var actionRefreshProducts = function() {
							productGrid.activeItem = null;
							productGrid.items = products.slice(0);	
						};
						
						var actionAddEditProduct = function(existingProduct) {
							var productWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Select Product',
								icon: 'vaadin:edit',
								width: .50,
								height: 275,
								listeners: {
									ready: function() {						
										productWin.show();
										
										var productFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',	
													children: [	
														{
															tag: 'vaadin-combo-box',											
															itemid: 'productItem',
															label: 'Product', 
															name: 'productCode',																														
															'item-value-path': 'code',
															'item-label-path': 'itemDesc',
															postinit: function(combo) {
																
																BillingService.getProductService().getEffectiveProductItems().then(function(data){
																	//format the code
																	var productItems = [];
																	data.forEach(function(item){																		
																		var productItem = item.productItem;
																		productItem.code = productItem.productItemPK.productCode + "-" + productItem.productItemPK.featureProductCode;
																		productItem.productItemPrices = item.productItemPrices;
																		productItem.defaultBillingCycleDay = item.defaultBillingCycleDay;
																		
																		//existing
																		var alreadyHasItem = false;																																			
																		products.forEach(function(existingItem){
																			if (existingItem.applicationProductPK.productCode === productItem.productItemPK.productCode &&
																				existingItem.applicationProductPK.featureProductCode === productItem.productItemPK.featureProductCode) {

																				alreadyHasItem = true;
																			}																			
																		});
																		if (alreadyHasItem && existingProduct &&
																			(existingProduct.applicationProductPK.productCode === productItem.productItemPK.productCode &&
																		    existingProduct.applicationProductPK.featureProductCode === productItem.productItemPK.featureProductCode)) {																				
																			    alreadyHasItem = false;
																		}
																		if (!alreadyHasItem) {
																			productItems.push(productItem);
																		}
																	});
																	productItems.sort(function(a, b){
																		var codeCompare = a.code.localeCompare(b.code);
																		return codeCompare === 0 ? a.itemDesc.localeCompare(b.itemDesc) : codeCompare;
																	});
																	
																	combo.items = productItems;
																	combo.required = true;
																});
															},
															listeners: {
																change: function() {
																	var productSelection = ElementUtil.query(productFormPanel, 'productItem').selectedItem;
																	var productPrice = ElementUtil.query(productFormPanel, 'productPrice');
																	var factorCount = ElementUtil.query(productFormPanel, 'factorCount');
																	var overrideFactor = ElementUtil.query(productFormPanel, 'overrideFactor');
																	
																	productPrice.value = productSelection.productItemPrices[0].itemPriceAmt;
																	if (productSelection.billingType === 'MFEE') {
																		factorCount.classList.remove('hide');
																		overrideFactor.classList.remove('hide');
																	} else {
																		factorCount.classList.add('hide');
																		overrideFactor.classList.add('hide');
																	}
																}
															}
														},
														{
															tag: 'vaadin-number-field',
															itemid: 'productPrice',
															label: 'Price',
															name: 'productPrice',
															required: true,
															min: -9999999,
															max: 9999999
														},
														{
															tag: 'vaadin-number-field',
															itemid: 'factorCount',
															label: 'Factor Count',
															name: 'initalFactorCount',
															min: -9999999,
															max: 9999999,
															postinit: function(field) {
																setTimeout(function(){																																
																	field.classList.add('hide');
																}, 50);
															}
														},
														{
															tag: 'vaadin-checkbox',
															itemid: 'overrideFactor',
															name: 'overrideFlag',																													
															label: 'Override Flag',
															postinit: function(field) {
																setTimeout(function(){																															
																	field.classList.add('hide');
																}, 50);																
															}
														}
													]
												},
												{
													tag: 'hr',
													colspan: 2
												},
												{
													tag: 'div',
													style: 'text-align: center;',
													colspan: 2,
													defaults: {
														tag: 'vaadin-button'
													},
													children: [
														{
															theme: 'primary',
															children: [
																ElementUtil.makeIcon('vaadin:database', ' Save')
															],
															listeners: {
																click: function() {															
																	var productSelection = ElementUtil.query(productFormPanel, 'productItem').selectedItem;
																	var data = productFormPanel.getData();
																	var defaultBillingCycleDay = productSelection.defaultBillingCycleDay;
																	
																	if (existingProduct) {
																		existingProduct.applicationProductPK.productCode = productSelection.productItemPK.productCode;
																		existingProduct.applicationProductPK.featureProductCode = productSelection.productItemPK.featureProductCode;
																		existingProduct.description = productSelection.itemDesc;
																		existingProduct.overrideFlag = data.overrideFlag;
																		existingProduct.initalFactorCount = data.initalFactorCount;
																		existingProduct.productPrice = data.productPrice;
																		existingProduct.orderQtyAmount = 1;
																		existingProduct.quantityUom = productSelection.productItemPrices[0].productQuantityUom;
																		existingProduct.defaultBillingCycleDay = defaultBillingCycleDay;
																		
																	} else {
																		var newProduct = data;
																		newProduct.applicationProductPK = {};
																		newProduct.applicationProductPK.productCode = productSelection.productItemPK.productCode;
																		newProduct.applicationProductPK.featureProductCode = productSelection.productItemPK.featureProductCode;
																		newProduct.description = productSelection.itemDesc;
																		newProduct.quantityUom = productSelection.productItemPrices[0].productQuantityUom;
																		newProduct.productPrice = data.productPrice;
																		newProduct.orderQtyAmount = 1;
																		newProduct.defaultBillingCycleDay = defaultBillingCycleDay;
																		
																		products.push(newProduct);
																	}

																	var billingStartDateField = ElementUtil.query(formPanel, 'billingStartDate');
																	var cycleDayField = ElementUtil.query(formPanel, 'cycleDay');
																	if (defaultBillingCycleDay && billingStartDateField && !billingStartDateField.value) {
																		cycleDayField.value = '' + defaultBillingCycleDay;
																		var today = new Date();
																		var month = String(today.getMonth() + 1).padStart(2, '0');
																		var day = String(defaultBillingCycleDay).padStart(2, '0');
																		billingStartDateField.value = today.getFullYear() + '-' + month + '-' + day;
																	}
																	
																	actionRefreshProducts();
																	productWin.close();	
																}
															}
														},
														{
															theme: 'tertiary',
															innerHTML: 'Cancel',
															style: 'margin-left: 10px;',
															listeners: {
																click: function() {
																	//cancel
																	productWin.close();
																}
															}
														}
													]
												}												
											]
										});								
										productWin.addToContentElement(productFormPanel);
										
										if (existingProduct) {
											existingProduct.productCode = existingProduct.applicationProductPK.productCode + '-' + existingProduct.applicationProductPK.featureProductCode;								
											productFormPanel.load(existingProduct);
										}
									}
								}
							});							
							
							
						};
				
						var actionRemoveProduct = function(existingProduct) {
							var newItems = [];
							products.forEach(function(item){
								if (!(item.applicationProductPK.productCode === existingProduct.applicationProductPK.productCode  
									&& item.applicationProductPK.featureProductCode === existingProduct.applicationProductPK.featureProductCode)) {
									newItems.push(item);
								}
							});	
							products = newItems;
							actionRefreshProducts();
						};
						
					}
				}
			});
			};
			
			Service.getBrandingService().getCurrentBranding().then(function(branding) {
				showAppWin(branding.ssoEnabled);
			});			
						
		};		
			

	}
	
};
customElements.define('dl-customer-apps-grid', CustomerAppsGrid);

